import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, spacing, breakpoints, utility } = useTheme();

  return {
    answer: css`
      padding-bottom: ${spacing.s};

      ${breakpoints.l} {
        padding-bottom: 1.5rem;
      }

      &:last-child {
        padding-bottom: 0;

        button {
          margin: auto;
        }
      }
    `,
    hiddenInputs: isSelected => css`
      input {
        ${utility.checkboxHidden}
      }

      ${breakpoints.s} {
        input:focus-visible:not(:hover) + button {
          span {
            text-decoration: underline;
            border-left: 2px solid ${colors.border_black};
            border-right: 2px solid ${colors.border_black};
            color: ${colors.border_black};
          }
          &::before {
            border: 2px solid ${colors.border_black};
            outline: none;
            border-radius: 4px;
            background-color: ${colors.skip_yellow};
          }
        }
      }
    `,
    buttonNext: arrowContext => css`
      font-family: 'FS Dillon';
      width: 327px;
      height: 48px;
      background-color: ${colors.red};
      color: ${colors.white};
      border: 1px ${colors.red} solid;
      border-radius: 4px;
      font-size: 16px;

      ${arrowContext === false &&
      css`
        background-color: ${colors.border_grey};
        color: ${colors.next_grey};
        border: 1px ${colors.border_grey} solid;
        cursor: initial;
      `}

      ${arrowContext === true &&
      css`
        background-color: ${colors.red};
        color: ${colors.white};
        cursor: pointer;
        &:focus-visible {
          outline: none;
          color: ${colors.border_black};
          border: 2px solid ${colors.border_black};
          background-color: ${colors.skip_yellow};
          text-decoration: underline;
        }
      `}

    ${breakpoints.l} {
        width: 391px;
      }
      &:not(:disabled) {
        &:hover {
          background-color: ${colors.white} !important;
          color: #16161e !important;
          border: none;
        }
      }
    `,
    button: (isSelected, bothAnswer) => css`
      ${bothAnswer === true &&
      css`
        &::before {
          background-color: ${colors.white};
        }
        span {
          color: ${colors.navy};
        }
      `}

      ${bothAnswer === true &&
      isSelected === false &&
      css`
        &::before {
          background-color: ${colors.white};
        }
      `}
      svg {
        width: 20px;
        height: 20px;
      }
      ${bothAnswer === true &&
      isSelected === false &&
      css`
        &:hover {
          &::before {
            background-color: ${colors.white};
          }
          span {
            color: ${colors.navy};
          }
        }
      `}
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          &::before {
            background-color: ${colors.white};
          }

          span {
            color: ${colors.navy};
          }
        }
      }

      ${isSelected &&
      css`
        &::before {
          background-color: ${colors.white};
        }

        span {
          color: ${colors.navy};
        }
      `}

      ${!isSelected &&
      css`
        svg {
          display: none;
        }
      `}

      ${breakpoints.l} {
        padding: ${spacing.m};

        &::before {
          background-size: 45%;
        }
      }
    `,
    mixedTitle: css`
      color: ${colors.darkGrey};
      font-size: 16px;
      line-height: 22px;
    `,
    visibility: isAnswerSelected => css`
      visibility: hidden;

      ${isAnswerSelected &&
      css`
        visibility: visible;
        animation: fade_in_show 1s ease-in alternate;

        @keyframes fade_in_show {
          0% {
            opacity: 0;
          }

          100% {
            opacity: 1;
          }
        }
      `}
    `,
  };
};
